'use client'

import {
  Column,
  Columns,
  Document,
  Dropcursor,
  Focus,
  Link,
  Placeholder,
  Selection,
  StarterKit,
  Subscript,
  Superscript,
  TaskItem,
  TaskList,
  TextAlign,
  TextStyle,
  TrailingNode,
  Underline,
} from '.'


export const ExtensionKit = () => [
  Document,
  Columns,
  TaskList,
  TaskItem.configure({
    nested: true,
  }),
  Column,
  Selection,
  StarterKit.configure({
    document: false,
    dropcursor: false,
    heading: false,
    horizontalRule: false,
    blockquote: false,
    history: {
      newGroupDelay: 200
    },
    codeBlock: false,
  }),
  TextStyle,
  TrailingNode,
  Link.configure({
    openOnClick: false,
  }),
  Underline,
  TextAlign.extend({
    addKeyboardShortcuts() {
      return {}
    },
  }).configure({
    types: ['heading', 'paragraph'],
  }),
  Subscript,
  Superscript,
  Placeholder.configure({
    includeChildren: true,
    showOnlyCurrent: false,
    placeholder: () => '',
  }),
  Focus,
  Dropcursor.configure({
    width: 2,
    class: 'ProseMirror-dropcursor border-black',
  }),
]

export default ExtensionKit
